import baseMigrate from "@Shared/Entities/AbstractEntities/BaseEntity/migrate";
import { Network } from "@Shared/Entities/Customer/Usage/enums";
import { Platform } from "@Shared/Entities/Supplier/InstantPackage/enums";
const version1 = (current = {}) => {
    const { version = 0 } = current;
    if (version >= 1) {
        return current;
    }
    return { ...current, version: 1 };
};
const isPlatform = (value) => {
    return Object.values(Platform).includes(value);
};
const convertPlatform = (platform) => {
    if (isPlatform(platform)) {
        return platform;
    }
    switch (platform) {
        case Network.EE:
            return Platform.EE;
        case Network.Vodafone:
            return Platform.Vodafone;
        case Network.Three:
            return Platform.Three;
        case Network.O2:
            return Platform.O2;
        case Network["plan.com"]:
            return Platform.EEPlan;
    }
};
const version2 = (current = {}) => {
    const { version = 0, platform } = current;
    if (version >= 2) {
        return current;
    }
    const convertedPlatform = convertPlatform(platform);
    return { ...current, version: 2, platform: convertedPlatform };
};
const version3 = (current = {}) => {
    const { version = 0, hardwareFunds } = current;
    if (version >= 3) {
        return current;
    }
    const lengthsSet = new Set(["length24", "length36"]);
    const formattedHardwareFunds = {};
    if (hardwareFunds) {
        for (const [tariffTypeKey, lengthsOrCostsObject] of Object.entries(hardwareFunds)) {
            const [keys] = Object.entries(lengthsOrCostsObject);
            keys.every((key) => lengthsSet.has(key))
                ? (formattedHardwareFunds[tariffTypeKey] = lengthsOrCostsObject)
                : (formattedHardwareFunds[tariffTypeKey] = {
                    length24: lengthsOrCostsObject,
                    length36: lengthsOrCostsObject,
                });
        }
    }
    return { ...current, version: 3, hardwareFunds: formattedHardwareFunds };
};
export default (original = {}) => {
    const baseMigrated = baseMigrate(original);
    const converted = [version1, version2, version3].reduce((converted, f) => f(converted), original);
    const { version, supplierId, name, descriptiveName, platform, tariffs, hardwareFunds, leasing, roaming, customerService, published = false, isTariffShown = false, additionalTariffs = false, } = converted;
    return {
        ...baseMigrated,
        version,
        supplierId,
        name,
        descriptiveName,
        platform,
        tariffs,
        hardwareFunds,
        leasing,
        roaming,
        customerService,
        published,
        isTariffShown,
        additionalTariffs,
    };
};
